import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames/bind'

import HeadBanner from '../banners/headBanner'
import CategoriesMenu from './categoriesMenu'
import MarketSiteMenu from './marketSiteMenu'
import GlobalHeader from './globalHeader'

import AccountIcon from '../icons/person'
import HamburgerIcon from '../icons/hamburger'

import styles from './index.module.css'

class SiteHeader extends React.Component {
  static propTypes = {
    currentSite: PropTypes.string.isRequired,
    toggleOffCanvas: PropTypes.func.isRequired,
    menuConfig: PropTypes.array.isRequired,
    user: PropTypes.object
  }

  toggleOffCanvasNav (direction, event) {
    event.preventDefault()
    this.props.toggleOffCanvas(direction)
  }

  render () {
    let { currentSite, user, menuConfig, banners } = this.props
    let cx = classNames.bind(styles)

    return (
      <div>
        <HeadBanner banners={banners} />
        <header className={styles.siteHeader}>
          <div className={styles.siteHeaderMiniWrapper}>
            <div className={styles.headerMini}>
              <div className={styles.btnAccount}>
                <a href='#account' className={styles.btnSquare} onClick={this.toggleOffCanvasNav.bind(this, 'right')}>
                  <AccountIcon width='14' height='14' />
                </a>
              </div>

              <div className={styles.btnCategories}>
                <a href='#categories' className={styles.btnSquare} onClick={this.toggleOffCanvasNav.bind(this, 'left')}>
                  <HamburgerIcon width='14' height='14' />
                </a>
              </div>

              <div>
                <a href='/' className={cx(styles[`logo-${currentSite}`])}>{currentSite}</a>
              </div>
            </div>

          </div>

          <GlobalHeader currentSite={currentSite} user={user} />

          <MarketSiteMenu currentSite={currentSite} />

          <div className={styles.headerCategoriesWrapper}>
            <div className={styles.headerCategories}>
              <div className={styles.gridWide}>
                <CategoriesMenu items={menuConfig} />
              </div>
            </div>
          </div>
        </header>
      </div>
    )
  }
}

export default SiteHeader



// WEBPACK FOOTER //
// ./client/components/siteHeader/index.js